import { Flex } from "antd"

export const Loading = () => {

    return (
        <Flex align={'center'} justify={'center'} style={{width: "100%", height: "100%"}}>
            <svg className="logo-loader" viewBox="0 0 500 500" width="120" height="120">
                <path className="logo-main"
                      d="m327.26 405.44v-0.12l90.81-57.93c7.52-4.7 12.09-12.95 12.09-21.82v-90.9c0-4.69-2.55-9.01-6.66-11.27-4.11-2.26-9.12-2.11-13.08 0.4l-86.38 54.71v0.21l-60.77 36.3c-8.12 4.86-18.25 4.86-26.38 0.01l-54.53-32.56c-3.87-2.32-6.24-6.51-6.24-11.03v-147.63c0-8.87-4.57-17.11-12.09-21.81l-74.35-47.04c-2.94-1.84-6.5-2.42-9.87-1.59-3.37 0.83-6.27 2.98-8.03 5.97-1.17 1.97-1.78 4.23-1.78 6.53v259.7c0 8.87 4.57 17.12 12.09 21.82l90.81 57.93v0.12l64.01 38.15c8.12 4.83 18.23 4.83 26.34 0z"/>
                <path className="logo-top"
                      d="m418.2 172.41c7.45-4.72 11.96-12.92 11.96-21.74v-84.8c0-6.89-5.43-12.56-12.31-12.86-2.6-0.12-5.17 0.57-7.37 1.95l-138.66 85.63c-7.52 4.7-12.09 12.95-12.09 21.82v84.86c0 4.69 2.55 9.01 6.66 11.27 4.11 2.26 9.12 2.11 13.08-0.4z"/>
            </svg>
        </Flex>
    )
}